(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["atomico-cart-benefits"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('atomico-cart-benefits')) {
  customElements.define('atomico-cart-benefits', class extends HTMLElement {
    connectedCallback() {
      this.drawer = this.closest('#drawer-cart');
      this.strings = JSON.parse(this.querySelector('[data-atomico-strings]').textContent);
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.update = event => {
        const cart = event.detail?.cart;
        if (!cart) return;
        this.latestCart = cart;
        this.renderCurrentCart();
      };
      document.addEventListener('theme:cart:change', this.update, options);
      const items = this.drawer.querySelector('[data-line-items]');
      if (items) {
        this.itemsObserver = new MutationObserver(() => this.renderCurrentCart());
        this.itemsObserver.observe(items, {childList: true, subtree: true});
      }
      this.drawer.addEventListener('click', event => {
        if (event.target.closest('[data-atomico-continue]')) this.drawer.querySelector('.drawer__close').click();
      }, options);
      this.drawer.addEventListener('theme:drawer:close', () => {
        const info = this.drawer.querySelector('.atomico-shipping');
        if (info) info.open = false;
      }, options);
      const info = this.drawer.querySelector('.atomico-shipping');
      if (info) {
        info.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') info.open = true; }, options);
        info.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') info.open = false; }, options);
        info.querySelector('summary').addEventListener('click', event => {
          if (event.pointerType === 'mouse') { event.preventDefault(); info.open = true; }
        }, options);
        document.addEventListener('click', event => { if (!info.contains(event.target)) info.open = false; }, options);
        info.addEventListener('keydown', event => {
          if (event.key === 'Escape' && info.open) {
            event.preventDefault(); event.stopPropagation(); info.open = false; info.querySelector('summary').focus();
          }
        }, options);
        info.addEventListener('focusout', event => { if (!info.contains(event.relatedTarget)) info.open = false; }, options);
      }
      requestAnimationFrame(() => this.render(Number(this.dataset.count), Number(this.dataset.total), Number(this.dataset.original), Number(this.dataset.items), this.dataset.currency));
    }
    disconnectedCallback() { this.controller?.abort(); this.itemsObserver?.disconnect(); }
    renderCurrentCart() {
      const cart = this.latestCart;
      if (!cart) return;
      const eligibility = new Map(Array.from(this.drawer.querySelectorAll('[data-atomico-promo-product]'), row => [row.dataset.atomicoPromoProduct, row.dataset.atomicoPromoEligible === 'true']));
      // New items wait for the theme's server-rendered rows, which include collection eligibility.
      if ((cart.items || []).some(item => !eligibility.has(String(item.product_id)))) return;
      const count = (cart.items || []).reduce((sum, item) => sum + (eligibility.get(String(item.product_id)) ? item.quantity : 0), 0);
      this.render(count, cart.total_price, cart.original_total_price, cart.item_count, cart.currency);
    }
    render(count, total, original, itemCount, currency) {
      const limit = Number(this.dataset.threshold);
      const isMexico = (currency || this.dataset.currency) === 'MXN';
      const free = isMexico && total >= limit;
      const money = value => new Intl.NumberFormat((currency || this.dataset.currency) === 'MXN' ? 'es-MX' : (document.documentElement.lang || 'en'), {style:'currency', currency: currency || 'MXN'}).format(value / 100);
      this.hidden = itemCount === 0;
      let message = this.strings.nextTwo;
      if (count === 1) message = this.strings.nextOne;
      if (count === 2) message = this.strings.nextThree;
      if (count === 3) message = this.strings.nextFour;
      if (count >= 3 && !free) {
        message = this.strings.remaining.replace('__AMOUNT__', money(Math.max(0, limit - total)));
      }
      if (free) {
        message = count < 4
          ? `${this.strings.qualified} ${message}`
          : this.strings.qualified;
      }
      if (!isMexico) message = this.strings.mexico;
      const messageElement = this.querySelector('.atomico-rewards__message');
      const highlightPattern = /(\d+\s+productos?\s+participantes?(?:\s+m[aá]s)?|\d+(?:[.,]\d+)?%\s+de\s+descuento(?:\s*\+\s*env[ií]o\s+gratis)?|env[ií]o\s+gratis|\$\s*[\d.,]+(?:\s*MXN)?)/giu;
      const formatLine = text => {
        const line = document.createElement('span');
        line.className = 'atomico-rewards__message-line';
        text.split(highlightPattern).forEach((part, index) => {
          if (!part) return;
          if (index % 2 === 0) {
            line.append(document.createTextNode(part));
          } else {
            const highlight = document.createElement('span');
            highlight.className = 'atomico-rewards__highlight';
            highlight.textContent = part;
            line.append(highlight);
          }
        });
        return line;
      };
      const lines = free && count < 4
        ? [this.strings.qualified, message.slice(this.strings.qualified.length).trim()]
        : [message];
      messageElement.replaceChildren(...lines.filter(Boolean).map(formatLine));
      this.querySelectorAll('[data-step]').forEach(step => {
        const earned = step.dataset.step === 'shipping' ? free : count >= Number(step.dataset.step);
        step.classList.toggle('is-earned', earned);
        step.setAttribute('aria-label', `${step.textContent.trim().replace(/\s+/g, ' ')}: ${earned ? this.strings.achieved : this.strings.pending}`);
      });
      const progress = this.querySelectorAll('[data-step].is-earned').length / 4;
            this.querySelector('.atomico-rewards__fill').style.transform = `scaleX(${progress})`;
                  const shipping = this.drawer.querySelector('[data-atomico-shipping-price]');
      if (shipping) shipping.textContent = isMexico ? (free ? this.strings.free : money(9900)) : this.strings.checkout;
      const discount = this.drawer.querySelector('[data-atomico-discount]');
      if (discount) {
        discount.hidden = original <= total;
        discount.querySelector('strong').textContent = `−${money(Math.max(0, original - total))}`;
      }
      const subtotal = this.drawer.querySelector('[data-cart-final]');
      if (subtotal) subtotal.textContent = `${money(total)} ${currency || 'MXN'}`;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atomico-cart-page-benefits"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('atomico-cart-page-benefits')) {
    customElements.define('atomico-cart-page-benefits', class extends HTMLElement {
      connectedCallback() {
        this.config = JSON.parse(this.querySelector('[data-acp-config]').textContent);
        this.container = this.closest('[data-section-type="cart"]');
        this.onChange = event => {
          if (!Array.isArray(event.detail?.cart?.items)) return;
          this.cart = event.detail.cart;
          this.updateFromCart();
        };
        document.addEventListener('theme:cart:change', this.onChange);
        const rows = this.container?.querySelector('[data-line-items]');
        if (rows) {
          this.observer = new MutationObserver(() => this.updateFromCart());
          this.observer.observe(rows, { childList: true, subtree: true });
        }
        this.render(this.config.count, this.config.total, this.config.items, this.config.currency);
      }
      disconnectedCallback() {
        document.removeEventListener('theme:cart:change', this.onChange);
        this.observer?.disconnect();
      }
      updateFromCart() {
        if (!this.cart || !this.container) return;
        const eligibility = new Map(Array.from(
          this.container.querySelectorAll('[data-atomico-promo-product]'),
          row => [row.dataset.atomicoPromoProduct, row.dataset.atomicoPromoEligible === 'true']
        ));
        if (this.cart.items.some(item => !eligibility.has(String(item.product_id)))) return;
        const count = this.cart.items.reduce((sum, item) => sum +
          (eligibility.get(String(item.product_id)) ? item.quantity : 0), 0);
        this.render(count, this.subtotal(this.cart), this.cart.item_count, this.cart.currency);
      }
      subtotal(cart) {
        const valid = value => Number.isSafeInteger(value) && value >= 0;
        if (!Array.isArray(cart.cart_level_discount_applications) ||
            !cart.items.every(item => valid(item.final_line_price))) return cart.total_price;
        const discounts = cart.cart_level_discount_applications.filter(d => d.target_type !== 'shipping_line');
        if (!discounts.every(d => valid(d.total_allocated_amount))) return cart.total_price;
        const total = cart.items.reduce((sum, item) => sum + item.final_line_price, 0) -
          discounts.reduce((sum, d) => sum + d.total_allocated_amount, 0);
        return valid(total) ? total : cart.total_price;
      }
      setMessage(element, text) {
        element.hidden = !text;
        if (element.dataset.message === text) return;
        element.dataset.message = text;
        const highlights = /(\d+\s+productos?\s+participantes?(?:\s+m[aá]s)?|\d+(?:[.,]\d+)?%\s+de\s+descuento|env[ií]o\s+gratis|\$\s*[\d.,]+(?:\s*MXN)?)/giu;
        const fragment = document.createDocumentFragment();
        text.split(highlights).forEach((part, index) => {
          if (index % 2) {
            const strong = document.createElement('strong');
            strong.textContent = part;
            fragment.append(strong);
          } else fragment.append(document.createTextNode(part));
        });
        element.replaceChildren(fragment);
      }
      render(count, total, items, currency) {
        this.hidden = items === 0;
        const c = this.config;
        const available = c.country === 'MX' && (currency || c.currency) === 'MXN' && c.limit > 0;
        const free = available && total >= c.limit;
        const amount = new Intl.NumberFormat('es-MX', {
          style: 'currency', currency: currency || c.currency
        }).format(Math.max(0, c.limit - total) / 100);
        this.setMessage(this.querySelector('[data-acp-shipping]'), available
          ? (free ? c.qualified : c.remaining.replace('__AMOUNT__', amount)) : c.mexico);
        this.setMessage(this.querySelector('[data-acp-next]'), count < 4 ? c.next[count] : '');
        this.querySelectorAll('[data-acp-step]').forEach(step => {
          const earned = step.dataset.acpStep === 'shipping' ? free : count >= Number(step.dataset.acpStep);
          step.classList.toggle('is-earned', earned);
          step.setAttribute('aria-label', `${step.textContent.trim().replace(/\s+/g, ' ')}: ${earned ? c.achieved : c.pending}`);
        });
        const progress = [count >= 3 ? 1 : 0,
          count >= 3 && available ? Math.max(0, Math.min(total / c.limit, 1)) : 0,
          free && count >= 4 ? 1 : 0];
        this.querySelectorAll('.acp-benefits__rail span').forEach((segment, i) => {
          segment.style.setProperty('--progress', progress[i]);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atomico-cart-recommendations"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('atomico-cart-recommendations')) {
  customElements.define('atomico-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      this.drawer = this.closest('[data-drawer]');
      this.rail = this.querySelector('[data-suggestions-rail]');
      this.status = this.querySelector('[data-suggestions-status]');
      this.strings = JSON.parse(this.querySelector('[data-suggestions-strings]').textContent);
      this.version = 0;
      this.priceState = null;
      this.drawer.addEventListener('theme:drawer:open', () => {
        this.opened = true;
        this.schedule();
      }, options);
      document.addEventListener('theme:cart:change', event => {
        this.cart = event.detail?.cart;
        this.priceState = null;
        this.renderPrices();
        if (!this.cart?.item_count) this.hidden = true;
        if (this.opened) this.schedule();
      }, options);
      document.addEventListener('atomico:refresh-prices', () => {
        this.cart = null;
        this.priceState = null;
        this.renderPrices();
        if (this.opened) this.schedule();
      }, options);
      this.addEventListener('change', event => {
        const select = event.target.closest('select[data-suggestion-variant]');
        if (!select) return;
        const card = select.closest('[data-suggestion-product]');
        card.querySelector('button[type="submit"]').disabled = !select.value;
        const option = select.selectedOptions[0];
        const price = card.querySelector('[data-suggestion-price]');
        if (option?.dataset.price) {
          price.dataset.baseLabel = option.dataset.price;
          price.dataset.baseCents = option.dataset.priceCents || '';
          price.dataset.pricePrefix = '';
          this.renderPrice(card);
        }
      }, options);
      this.addEventListener('submit', event => {
        const form = event.target.closest('[data-suggestion-form]');
        if (!form) return;
        event.preventDefault();
        this.add(form);
      }, options);
    }
    disconnectedCallback() {
      this.events?.abort();
      this.request?.abort();
      clearTimeout(this.timer);
    }
    renderPrices() {
      this.rail.querySelectorAll('[data-suggestion-product]').forEach(card => this.renderPrice(card));
    }
    renderPrice(card) {
      const price = card.querySelector('[data-suggestion-price]');
      if (!price?.dataset.baseLabel) return;
      const label = price.dataset.baseLabel;
      const prefix = price.dataset.pricePrefix;
      const base = Number(price.dataset.baseCents);
      price.textContent = [prefix, label].filter(Boolean).join(' ');
      const state = this.priceState;
      if (!state || card.dataset.priceEligible !== 'true' || state.currency !== this.cart?.currency || !Number.isSafeInteger(base) || base <= 0 || state.rate <= 0 || state.rate >= 100) return;
      const discounted = base - Math.round(base * state.rate / 100);
      let formatted;
      try {
        formatted = new Intl.NumberFormat(state.currency === 'MXN' ? 'es-MX' : (document.documentElement.lang || 'en'), {
          style: 'currency', currency: state.currency, currencyDisplay: 'narrowSymbol'
        }).format(discounted / 100) + ' ' + state.currency;
      } catch { return; }
      const original = document.createElement('s');
      const accessible = document.createElement('span');
      accessible.className = 'visually-hidden';
      accessible.textContent = this.strings.regular + ' ';
      original.append(accessible, document.createTextNode(label));
      const earned = document.createElement('strong');
      earned.textContent = formatted;
      price.replaceChildren(...(prefix ? [document.createTextNode(prefix + ' ')] : []), original, earned);
    }
    async readPriceState(signal) {
      try {
        const url = new URL(this.dataset.root, location.origin);
        url.search = new URLSearchParams({sections: 'atomico-price-state', _atomico_price: String(Date.now())});
        const response = await fetch(url, {signal, credentials: 'same-origin', cache: 'no-store'});
        if (!response.ok) return null;
        const sections = await response.json();
        if (typeof sections['atomico-price-state'] !== 'string') return null;
        const fragment = new DOMParser().parseFromString(sections['atomico-price-state'], 'text/html');
        const data = JSON.parse(fragment.querySelector('[data-atomico-price-state]').textContent);
        return Number.isFinite(data.rate) && Number.isInteger(data.count) && typeof data.currency === 'string' ? data : null;
      } catch { return null; }
    }
    schedule() {
      clearTimeout(this.timer);
      this.version += 1;
      this.request?.abort();
      this.timer = setTimeout(() => { if (!this.busy) this.load(); }, 180);
    }
    async load() {
      const version = this.version;
      const request = new AbortController();
      this.request = request;
      const signal = request.signal;
      const timeout = setTimeout(() => request.abort(), 10000);
      try {
        if (!this.cart) {
          const response = await fetch(this.dataset.root + 'cart.js', {signal, cache: 'no-store'});
          if (!response.ok) throw new Error();
          this.cart = await response.json();
        }
        if (!this.cart.item_count) { this.hidden = true; return; }
        const url = new URL(this.dataset.root, location.origin);
        url.search = new URLSearchParams({section_id: 'atomico-cart-suggestions'});
        const [response, priceState] = await Promise.all([
          fetch(url, {signal, cache: 'no-store'}),
          this.readPriceState(signal)
        ]);
        if (!response.ok) throw new Error();
        const fragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = fragment.querySelector('[data-suggestions-content]');
        if (!content || version !== this.version) return;
        const inCart = new Set(this.cart.items.map(item => String(item.product_id)));
        const candidates = Array.from(content.querySelectorAll('[data-suggestion-product]')).filter(card => !inCart.has(card.dataset.suggestionProduct));
        for (let index = candidates.length - 1; index > 0; index -= 1) {
          const other = Math.floor(Math.random() * (index + 1));
          [candidates[index], candidates[other]] = [candidates[other], candidates[index]];
        }
        const cards = candidates.slice(0, 12);
        this.querySelector('[data-suggestions-intro]').textContent = content.dataset.intro;
        const focused = this.contains(document.activeElement);
        const oldScroll = this.rail.scrollLeft;
        this.priceState = priceState?.currency === content.dataset.currency && priceState.count === Number(content.dataset.participantCount) ? priceState : null;
        this.rail.replaceChildren(...cards);
        this.renderPrices();
        this.rail.scrollLeft = oldScroll;
        this.hidden = cards.length === 0;
        if (focused && cards.length) cards[0].querySelector('a')?.focus({preventScroll: true});
      } catch (error) {
        if (error.name !== 'AbortError') this.hidden = true;
      } finally {
        clearTimeout(timeout);
      }
    }
    async add(form) {
      if (this.busy || !form.reportValidity()) return;
      const input = form.querySelector('[name="id"]');
      if (!input?.value) return;
      this.busy = true;
      const button = form.querySelector('button[type="submit"]');
      const label = button.textContent;
      button.disabled = true;
      button.textContent = this.strings.adding;
      this.status.textContent = '';
      let added = false;
      try {
        const response = await fetch(this.dataset.root + 'cart/add.js', {
          method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: [{id: Number(input.value), quantity: 1}]})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.strings.error);
        added = true;
        this.status.textContent = this.strings.added;
        this.cart = null;
        const fresh = await fetch(this.dataset.root + 'cart.js', {cache: 'no-store'});
        if (!fresh.ok) throw new Error();
        this.cart = await fresh.json();
        document.dispatchEvent(new CustomEvent('theme:cart:change', {detail: {cart: this.cart}, bubbles: true}));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
      } catch (error) {
        this.status.textContent = added ? this.strings.added : (error.message || this.strings.error);
        if (added) this.drawer.dispatchEvent(new CustomEvent('theme:drawer:open', {detail: {reinit: true}, bubbles: true}));
      } finally {
        this.busy = false;
        button.disabled = false;
        button.textContent = label;
        if (added) this.schedule();
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atomico-cart-scroll-hint"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('atomico-cart-scroll-hint')) {
    customElements.define('atomico-cart-scroll-hint', class extends HTMLElement {
      connectedCallback() {
        this.drawer = this.closest('#drawer-cart');
        this.button = this.querySelector('button');
        if (!this.drawer || !this.button) return;
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
        };
        this.advance = () => {
          if (!this.scroller) return;
          this.scroller.scrollBy({ top: Math.max(80, this.scroller.clientHeight * .7),
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        this.button.addEventListener('click', this.advance);
        this.drawer.addEventListener('scroll', this.schedule, true);
        this.drawer.addEventListener('toggle', this.schedule, true);
        this.drawer.addEventListener('load', this.schedule, true);
        window.addEventListener('resize', this.schedule);
        this.changes = new MutationObserver(this.schedule);
        this.changes.observe(this.drawer, { childList: true, subtree: true });
        this.visibility = new MutationObserver(this.schedule);
        this.visibility.observe(this.drawer, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
        this.sizes = new ResizeObserver(this.schedule);
        this.sizes.observe(this.drawer);
        this.schedule();
      }
      update() {
        const items = this.drawer.querySelector('[data-line-items]');
        const rows = items ? items.querySelectorAll('[data-cart-item]') : [];
        let scroller = items;
        while (scroller && scroller !== this.drawer) {
          if (/(auto|scroll)/.test(getComputedStyle(scroller).overflowY)) break;
          scroller = scroller.parentElement;
        }
        if (scroller === this.drawer) scroller = null;
        if (this.items !== items || this.scroller !== scroller) {
          this.sizes.disconnect();
          this.sizes.observe(this.drawer);
          if (items) this.sizes.observe(items);
          if (scroller) this.sizes.observe(scroller);
          this.items = items;
          this.scroller = scroller;
        }
        let more = false;
        if (scroller && rows.length && matchMedia('(max-width: 767px)').matches && this.drawer.classList.contains('drawer--visible')) {
          const edge = scroller.getBoundingClientRect().top + scroller.clientTop + scroller.clientHeight;
          const last = rows[rows.length - 1].getBoundingClientRect();
          more = scroller.clientHeight > 0 && last.bottom > edge + 4 &&
            scroller.scrollHeight - scroller.clientHeight - scroller.scrollTop > 4;
        }
        if (more) {
          clearTimeout(this.hideTimer);
          this.hideTimer = null;
          this.button.hidden = false;
          this.button.classList.remove('is-leaving');
        } else if (!this.button.hidden && !this.hideTimer) {
          this.button.classList.add('is-leaving');
          const delay = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 220;
          this.hideTimer = setTimeout(() => {
            this.button.hidden = true;
            this.hideTimer = null;
          }, delay);
        }
      }
      disconnectedCallback() {
        clearTimeout(this.hideTimer);
        cancelAnimationFrame(this.frame);
        this.changes?.disconnect();
        this.visibility?.disconnect();
        this.sizes?.disconnect();
        this.button?.removeEventListener('click', this.advance);
        this.drawer?.removeEventListener('scroll', this.schedule, true);
        this.drawer?.removeEventListener('toggle', this.schedule, true);
        this.drawer?.removeEventListener('load', this.schedule, true);
        window.removeEventListener('resize', this.schedule);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atomico-earned-price"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('atomico-earned-price')) return;
    let state = null;
    let revision = 0;
    let controller;
    let timer;
    const elements = new Set();
    const updateAll = () => elements.forEach(element => element.update());
    const refresh = () => {
      clearTimeout(timer);
      controller?.abort();
      const requestRevision = ++revision;
      state = null;
      updateAll();
      timer = setTimeout(async () => {
        if (!elements.size) return;
        const requestController = new AbortController();
        controller = requestController;
        const timeout = setTimeout(() => requestController.abort(), 8000);
        try {
          const url = new URL(window.location.href);
          url.searchParams.delete('section_id');
          url.searchParams.set('sections', 'atomico-price-state');
          url.searchParams.set('_atomico_price', String(Date.now()));
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: requestController.signal });
          if (!response.ok) throw new Error('Price state unavailable');
          const sections = await response.json();
          if (typeof sections['atomico-price-state'] !== 'string') throw new Error('Missing price state');
          const parsed = new DOMParser().parseFromString(sections['atomico-price-state'], 'text/html');
          const data = JSON.parse(parsed.querySelector('[data-atomico-price-state]').textContent);
          if (!Number.isFinite(data.rate) || typeof data.currency !== 'string') throw new Error('Invalid price state');
          if (requestRevision === revision) {
            state = data;
            updateAll();
          }
        } catch {
          if (requestRevision === revision) {
            state = null;
            updateAll();
          }
        } finally {
          clearTimeout(timeout);
        }
      }, 120);
    };
    class AtomicoEarnedPrice extends HTMLElement {
      static get observedAttributes() { return ['data-eligible', 'data-currency']; }
      connectedCallback() {
        elements.add(this);
        this.observer?.disconnect();
        this.observer = new MutationObserver(() => this.update());
        this.observer.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'data-earned-rate'] });
        this.update();
        if (!state) refresh();
      }
      disconnectedCallback() {
        elements.delete(this);
        this.observer?.disconnect();
      }
      attributeChangedCallback() { this.update(); }
      update() {
        const native = this.querySelector('[data-native-price]');
        const earned = this.querySelector('[data-earned-price]');
        if (!native || !earned) return;
        const options = [...earned.querySelectorAll('[data-earned-rate]')];
        const active = state && this.dataset.eligible === 'true' && this.dataset.currency === state.currency && state.rate > 0
          ? options.find(option => Number(option.dataset.earnedRate) === state.rate) : null;
        options.forEach(option => {
          if (option.hidden !== (option !== active)) option.hidden = option !== active;
        });
        if (native.hidden !== Boolean(active)) native.hidden = Boolean(active);
        if (earned.hidden !== !active) earned.hidden = !active;
      }
    }
    customElements.define('atomico-earned-price', AtomicoEarnedPrice);
    document.addEventListener('theme:cart:change', refresh);
    document.addEventListener('atomico:refresh-prices', refresh);
    window.addEventListener('pageshow', refresh);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') refresh();
    });
    refresh();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atomico-promotion-announcement"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('atomico-announcement')) {
  customElements.define('atomico-announcement', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      this.strings = JSON.parse(this.querySelector('[data-shipping-strings]').textContent);
      this.message = this.querySelector('[data-shipping-message]');
      this.render(JSON.parse(this.querySelector('[data-shipping-state]').textContent));
      document.addEventListener('theme:cart:change', event => {
        if (event.detail?.cart) {
          this.request?.abort();
          clearTimeout(this.timer);
          this.render(event.detail.cart);
        } else this.schedule();
      }, options);
      document.addEventListener('atomico:refresh-prices', () => this.schedule(), options);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.schedule(); }, options);
      window.addEventListener('pageshow', () => this.schedule(), options);
      this.schedule();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.request?.abort();
      clearTimeout(this.timer);
    }
    schedule() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.refresh(), 150);
    }
    async refresh() {
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      const timeout = setTimeout(() => request.abort(), 8000);
      try {
        const response = await fetch(this.dataset.root + 'cart.js', {signal: request.signal, cache: 'no-store'});
        if (response.ok) {
          const cart = await response.json();
          if (!request.signal.aborted) this.render(cart);
        }
      } catch (_) {} finally { clearTimeout(timeout); }
    }
    render(cart) {
      const limit = Number(this.dataset.limit);
      const eligible = this.dataset.country === 'MX' && cart.currency === 'MXN' && cart.requires_shipping;
      let message = this.strings.initial;
      if (eligible && cart.item_count > 0 && limit > 0) {
        if (cart.total_price >= limit) message = this.strings.earned;
        else {
          const amount = new Intl.NumberFormat('es-MX', {style: 'currency', currency: 'MXN', currencyDisplay: 'narrowSymbol'}).format((limit - cart.total_price) / 100);
          message = this.strings.remaining.replace('__AMOUNT__', amount + ' MXN');
        }
      }
      if (this.message.textContent !== message) this.message.textContent = message;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atomico-quick-shop"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('atomico-quick-shop')) return;
    let opened = null;
    let sequence = 0;
    class AtomicoQuickShop extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = {signal: this.events.signal};
        this.trigger = this.querySelector('[data-quick-open]');
        if (!this.trigger) return;
        this.panel = this.querySelector('[data-quick-panel]');
        this.content = this.querySelector('[data-quick-content]');
        this.status = this.querySelector('[data-quick-status]');
        this.success = this.querySelector('[data-quick-success]');
        this.strings = JSON.parse(this.querySelector('[data-quick-strings]').textContent);
        this.panel.id = 'AtomicoQuickShop-' + ++sequence;
        this.trigger.setAttribute('aria-controls', this.panel.id);
        this.trigger.addEventListener('click', () => this.panel.hidden ? this.open() : this.close(true), options);
        this.querySelectorAll('[data-quick-close]').forEach(button => button.addEventListener('click', () => this.close(true), options));
        this.querySelector('[data-quick-cart]').addEventListener('click', event => {
          const drawer = document.querySelector('[data-drawer="drawer-cart"]');
          if (!drawer) return;
          event.preventDefault();
          this.close(false);
          drawer.dispatchEvent(new CustomEvent('theme:drawer:open', {detail: {reinit: true}, bubbles: true}));
        }, options);
        this.addEventListener('change', () => { this.updateVariant(); this.syncPicker(); }, options);
        this.addEventListener('submit', event => { event.preventDefault(); this.add(event.target); }, options);
        this.addEventListener('keydown', event => {
          if (event.defaultPrevented) return;
          if (event.key === 'Escape' && !this.panel.hidden) {
            event.preventDefault();
            event.stopPropagation();
            if (this.pickerOpen) this.closePicker(); else this.close(true);
          }
        }, options);
        this.addEventListener('pointerdown', event => event.stopPropagation(), options);
        this.addEventListener('click', event => event.stopPropagation(), options);
        if (this.loaded) this.setupPicker();
      }
      disconnectedCallback() {
        clearTimeout(this.successTimer);
        this.closePicker();
        this.events?.abort();
        this.request?.abort();
        if (opened === this) opened = null;
      }
      async open() {
        if (opened && opened !== this) opened.close(false);
        opened = this;
        this.trigger.setAttribute('aria-expanded', 'true');
        this.panel.hidden = false;
        this.dispatchEvent(new CustomEvent('atomico:quick-shop:open', {bubbles: true}));
        const card = this.closest('.product-grid-item');
        const image = card?.querySelector('.lazy-image');
        if (image) this.style.setProperty('--quick-image-height', Math.max(100, image.clientHeight - 12) + 'px');
        const slider = card?.closest('[data-custom-scrollbar-items], [data-slideshow]');
        if (slider && /auto|scroll/.test(getComputedStyle(slider).overflowX) && slider.scrollWidth > slider.clientWidth) {
          const itemRect = card.getBoundingClientRect();
          const sliderRect = slider.getBoundingClientRect();
          slider.scrollTo({left: slider.scrollLeft + itemRect.left + itemRect.width / 2 - sliderRect.left - slider.clientWidth / 2, behavior: 'smooth'});
        }
        if (!this.loaded) await this.load();
        if (opened === this) (this.picker || this.panel.querySelector('select') || this.panel.querySelector('[data-quick-close]'))?.focus({preventScroll: true});
      }
      close(focus) {
        clearTimeout(this.successTimer);
        this.closePicker();
        this.panel.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
        if (opened === this) opened = null;
        if (focus) this.trigger.focus({preventScroll: true});
        if (!this.busy) {
          this.removeAttribute('data-added');
          this.success.hidden = true;
          this.content.removeAttribute('inert');
          this.content.removeAttribute('aria-hidden');
        }
      }
      async load() {
        this.request?.abort();
        const request = new AbortController();
        this.request = request;
        const timeout = setTimeout(() => request.abort(), 10000);
        this.status.textContent = this.strings.loading;
        this.panel.setAttribute('aria-busy', 'true');
        try {
          const url = new URL(this.dataset.productUrl, location.origin);
          url.searchParams.set('section_id', 'atomico-quick-shop-options');
          const response = await fetch(url, {signal: request.signal, credentials: 'same-origin', cache: 'no-store'});
          if (!response.ok) throw new Error();
          const fragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = fragment.querySelector('[data-quick-options]');
          if (!content || request !== this.request) throw new Error();
          this.content.replaceChildren(document.importNode(content, true));
          this.loaded = true;
          this.status.textContent = '';
          this.setupPicker();
          this.updateVariant();
        } catch {
          if (this.isConnected && request === this.request) this.status.textContent = this.strings.loadError;
        } finally {
          clearTimeout(timeout);
          this.panel.removeAttribute('aria-busy');
        }
      }
      setupPicker() {
        const select = this.content.querySelector('select[name="id"]');
        if (!select || typeof HTMLElement.prototype.showPopover !== 'function') return;
        this.closePicker();
        this.picker?.remove();
        this.optionList?.remove();
        this.variantSelect = select;
        this.picker = document.createElement('button');
        this.picker.type = 'button';
        this.picker.className = 'atomico-quick-shop__picker';
        this.picker.setAttribute('role', 'combobox');
        this.picker.setAttribute('aria-haspopup', 'listbox');
        this.picker.setAttribute('aria-expanded', 'false');
        this.picker.setAttribute('aria-required', 'true');
        this.picker.setAttribute('aria-label', select.getAttribute('aria-label'));
        this.pickerLabel = document.createElement('span');
        this.pickerLabel.className = 'atomico-quick-shop__picker-label';
        this.picker.append(this.pickerLabel);
        this.optionList = document.createElement('div');
        this.optionList.className = 'atomico-quick-shop__options';
        this.optionList.id = this.panel.id + '-options';
        this.optionList.setAttribute('popover', 'manual');
        this.optionList.setAttribute('role', 'listbox');
        this.optionList.setAttribute('aria-label', select.getAttribute('aria-label'));
        this.picker.setAttribute('aria-controls', this.optionList.id);
        this.choiceNodes = [...select.options].filter(option => option.value).map((option, index) => {
          const choice = document.createElement('div');
          choice.id = this.optionList.id + '-' + index;
          choice.className = 'atomico-quick-shop__option';
          choice.setAttribute('role', 'option');
          choice.setAttribute('aria-selected', 'false');
          choice.setAttribute('aria-disabled', String(option.disabled));
          choice.dataset.value = option.value;
          choice.textContent = option.textContent;
          this.optionList.append(choice);
          return choice;
        });
        select.before(this.picker, this.optionList);
        select.hidden = true;
        select.required = false;
        this.syncPicker();
        const options = {signal: this.events.signal};
        this.picker.addEventListener('click', () => this.pickerOpen ? this.closePicker() : this.openPicker(), options);
        this.picker.addEventListener('keydown', event => this.onPickerKey(event), options);
        this.optionList.addEventListener('pointerdown', event => event.preventDefault(), options);
        this.optionList.addEventListener('click', event => {
          const choice = event.target.closest('[role="option"]');
          if (choice && this.optionList.contains(choice)) this.chooseVariant(choice);
        }, options);
        document.addEventListener('pointerdown', event => {
          if (this.pickerOpen && !this.picker.contains(event.target) && !this.optionList.contains(event.target)) this.closePicker();
        }, options);
        window.addEventListener('resize', () => this.positionPicker(), options);
        window.addEventListener('scroll', event => {
          if (this.pickerOpen && !this.optionList.contains(event.target)) this.positionPicker();
        }, {...options, capture: true});
      }
      syncPicker() {
        if (!this.picker) return;
        this.pickerLabel.textContent = this.variantSelect.selectedOptions[0]?.textContent || '';
        this.choiceNodes.forEach(choice => choice.setAttribute('aria-selected', String(choice.dataset.value === this.variantSelect.value)));
      }
      openPicker() {
        if (!this.picker || this.busy) return;
        this.optionList.showPopover();
        this.pickerOpen = true;
        this.picker.setAttribute('aria-expanded', 'true');
        this.positionPicker();
        const current = this.choiceNodes.find(choice => choice.dataset.value === this.variantSelect.value);
        this.setActiveChoice(current || this.availableChoices()[0]);
      }
      closePicker() {
        clearTimeout(this.typeTimer);
        this.typeSearch = '';
        if (this.optionList?.matches(':popover-open')) this.optionList.hidePopover();
        this.pickerOpen = false;
        this.picker?.setAttribute('aria-expanded', 'false');
        this.picker?.removeAttribute('aria-activedescendant');
      }
      positionPicker() {
        if (!this.pickerOpen) return;
        const rect = this.picker.getBoundingClientRect();
        const viewport = window.visualViewport;
        const top = viewport?.offsetTop || 0;
        const left = viewport?.offsetLeft || 0;
        const height = viewport?.height || window.innerHeight;
        const width = viewport?.width || window.innerWidth;
        if (rect.bottom < top || rect.top > top + height) { this.closePicker(); return; }
        const below = top + height - rect.bottom - 12;
        const above = rect.top - top - 12;
        const goBelow = below >= Math.min(220, this.optionList.scrollHeight) || below >= above;
        const maxHeight = Math.max(64, Math.min(220, goBelow ? below : above));
        Object.assign(this.optionList.style, {
          width: Math.min(rect.width, width - 16) + 'px',
          left: Math.max(left + 8, Math.min(rect.left, left + width - rect.width - 8)) + 'px',
          maxHeight: maxHeight + 'px',
          top: (goBelow ? rect.bottom + 6 : rect.top - Math.min(maxHeight, this.optionList.scrollHeight + 2) - 6) + 'px'
        });
      }
      availableChoices() { return this.choiceNodes.filter(choice => choice.getAttribute('aria-disabled') !== 'true'); }
      setActiveChoice(choice) {
        if (!choice) return;
        this.activeChoice = choice;
        this.choiceNodes.forEach(node => node.toggleAttribute('data-active', node === choice));
        this.picker.setAttribute('aria-activedescendant', choice.id);
        choice.scrollIntoView({block: 'nearest'});
      }
      chooseVariant(choice, focus = true) {
        if (!choice || choice.getAttribute('aria-disabled') === 'true') return;
        this.variantSelect.value = choice.dataset.value;
        this.variantSelect.dispatchEvent(new Event('change', {bubbles: true}));
        this.closePicker();
        if (focus) this.picker.focus({preventScroll: true});
      }
      onPickerKey(event) {
        const choices = this.availableChoices();
        if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          const wasOpen = this.pickerOpen;
          if (!wasOpen) this.openPicker();
          let index = choices.indexOf(this.activeChoice);
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = choices.length - 1;
          else if (wasOpen) index = Math.max(0, Math.min(choices.length - 1, index + (event.key === 'ArrowDown' ? 1 : -1)));
          this.setActiveChoice(choices[index]);
        } else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          if (this.pickerOpen) this.chooseVariant(this.activeChoice); else this.openPicker();
        } else if (event.key === 'Escape' && this.pickerOpen) {
          event.preventDefault();
          event.stopPropagation();
          this.closePicker();
        } else if (event.key === 'Tab' && this.pickerOpen) {
          this.chooseVariant(this.activeChoice, false);
        } else if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
          event.preventDefault();
          if (!this.pickerOpen) this.openPicker();
          clearTimeout(this.typeTimer);
          this.typeSearch = (this.typeSearch || '') + event.key.toLocaleLowerCase();
          const match = choices.find(choice => choice.textContent.trim().toLocaleLowerCase().startsWith(this.typeSearch));
          if (match) this.setActiveChoice(match);
          this.typeTimer = setTimeout(() => { this.typeSearch = ''; }, 700);
        }
      }
      updateVariant() {
        const form = this.content.querySelector('form');
        if (!form) return;
        const input = form.elements.id;
        const option = input.selectedOptions?.[0];
        const button = form.querySelector('button[type="submit"]');
        button.disabled = this.busy || !input.value || Boolean(option?.disabled);
        const price = this.content.querySelector('atomico-earned-price');
        if (!price) return;
        const baseValue = option?.dataset.price || this.content.querySelector('[data-quick-options]')?.dataset.basePrice;
        if (baseValue === undefined) return;
        const base = Number(baseValue);
        if (!Number.isFinite(base)) return;
        const formatter = new Intl.NumberFormat(this.dataset.currency === 'MXN' ? 'es-MX' : document.documentElement.lang, {style: 'currency', currency: this.dataset.currency, currencyDisplay: 'narrowSymbol'});
        const label = formatter.format(base / 100);
        price.querySelector('[data-native-price]').textContent = label;
        price.querySelectorAll('[data-earned-rate]').forEach(rate => {
          rate.querySelector('s').textContent = label;
          const cents = base - Math.round(base * Number(rate.dataset.earnedRate) / 100);
          rate.querySelector('strong').textContent = formatter.format(cents / 100);
        });
      }
      async add(form) {
        if (this.busy || !form.reportValidity() || !form.elements.id?.value) return;
        this.busy = true;
        const button = form.querySelector('button[type="submit"]');
        const label = button.textContent;
        button.disabled = true;
        button.textContent = this.strings.adding;
        this.status.textContent = '';
        let added = false;
        try {
          const root = this.dataset.root.replace(/\/?$/, '/');
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST', credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', Accept: 'application/json'},
            body: JSON.stringify({items: [{id: Number(form.elements.id.value), quantity: 1}]})
          });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.strings.addError);
          added = true;
          this.setAttribute('data-added', '');
          this.success.hidden = false;
          this.content.setAttribute('inert', '');
          this.content.setAttribute('aria-hidden', 'true');
          this.closePicker();
          clearTimeout(this.successTimer);
          this.successTimer = setTimeout(() => {
            if (this.isConnected && this.hasAttribute('data-added')) this.close(this.contains(document.activeElement));
          }, 7000);
          if (opened === this) this.querySelector('[data-quick-confirmation]').focus({preventScroll: true});
          try {
            const fresh = await fetch(root + 'cart.js', {credentials: 'same-origin', cache: 'no-store'});
            if (!fresh.ok) throw new Error();
            const cart = await fresh.json();
            document.dispatchEvent(new CustomEvent('theme:cart:change', {detail: {cart}, bubbles: true}));
            document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
          } catch {
            document.dispatchEvent(new CustomEvent('theme:cart:init', {bubbles: true}));
            document.dispatchEvent(new CustomEvent('atomico:refresh-prices', {bubbles: true}));
          }
        } catch (error) {
          this.status.textContent = error.message === 'Failed to fetch' ? this.strings.addError : (error.message || this.strings.addError);
        } finally {
          this.busy = false;
          button.textContent = label;
          this.updateVariant();
          if (added && opened !== this) this.close(false);
        }
      }
    }
    customElements.define('atomico-quick-shop', AtomicoQuickShop);
    document.addEventListener('click', event => { if (opened && !opened.contains(event.target)) opened.close(false); });
    document.addEventListener('focusin', event => { if (opened && !opened.contains(event.target)) opened.close(false); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    (() => {
  const pending = new WeakMap();
  window.addEventListener('theme:section:navigate', event => {
    const section = document.getElementById('shopify-section-' + event.detail?.sectionId);
    if (!section) return;
    const target = section.querySelector('.product__details > .best-fit-size-chart');
    const button = target?.querySelector('.scr-open-size-chart');
    if (!button) return;
    const handle = section.querySelector('[data-product-handle]')?.dataset.productHandle;
    pending.get(section)?.disconnect();
    const observer = new MutationObserver(() => {
      if (section.querySelector('[data-product-handle]')?.dataset.productHandle !== handle) {
        observer.disconnect();
        return;
      }
      const current = section.querySelector('.product__details > .best-fit-size-chart');
      if (current && !current.querySelector('.scr-open-size-chart')) {
        current.appendChild(button);
        observer.disconnect();
      }
    });
    pending.set(section, observer);
    observer.observe(section, { childList: true, subtree: true });
  });
})();

(() => {
  const pending = new WeakSet();
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (event.defaultPrevented || !form.matches('form.shopify-product-form[data-product-handle]')) return;
    const drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (!drawer || document.querySelector('[data-ajax-disable]')) return;
    event.preventDefault();
    if (pending.has(form)) return;
    pending.add(form);
    const button = form.querySelector('[data-add-to-cart]');
    const errors = form.querySelector('[data-add-action-errors]');
    if (errors) errors.textContent = '';
    if (button) { button.disabled = true; button.classList.add('loading'); }
    try {
      const route = window.theme.routes.cart;
      const response = await fetch(route + '/add.js', {
        method: 'POST', body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
      });
      const variant = await response.json();
      if (!response.ok) throw new Error(typeof variant.description === 'string' ? variant.description : 'No pudimos agregar el producto. Intenta de nuevo.');
      drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { detail: { variant, reinit: true }, bubbles: true }));
      fetch(route + '.js').then(response => response.json()).then(cart => {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart }, bubbles: true }));
      }).catch(() => {});
    } catch (error) {
      if (errors) { errors.textContent = error.message; errors.hidden = false; errors.style.display = 'block'; errors.setAttribute('role', 'alert'); }
    } finally {
      pending.delete(form);
      if (button) { button.disabled = false; button.classList.remove('loading'); }
    }
  });
})();


(() => {
  const connected = new WeakSet();
  function connect() {
    document.querySelectorAll('form.shopify-product-form[data-product-handle]').forEach(form => {
      if (connected.has(form) || !form.querySelector('.cl-po--wrapper')) return;
      connected.add(form);
      const submit = form.submit.bind(form);
      form.submit = function () {
        if (!document.querySelector('[data-drawer="drawer-cart"]')) return submit();
        if (form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))) submit();
      };
    });
  }
  window.addEventListener('options:rendered', connect);
  document.addEventListener('DOMContentLoaded', connect);
  connect();
})();

// Keep the live personalizer mounted; refresh only the theme's variant controls.
window.atomicoChangeVariant = async function (component, url, id, media) {
  const root = component.$el.closest('[data-product-handle]');
  const form = root?.querySelector('form.shopify-product-form');
  const section = root?.closest('.shopify-section');
  const personalizer = form?.querySelector('.cl-po--wrapper');
  if (!form || !section) {
    return component.changeVariant(url, id, media);
  }
  const sequence = (form._atomicoVariantSequence || 0) + 1;
  form._atomicoVariantSequence = sequence;
  const button = form.querySelector('[data-add-to-cart]');
  const errors = form.querySelector('[data-add-action-errors]');
  if (button) button.disabled = true;
  try {
    const request = new URL(url, location.href);
    request.searchParams.set('section_id', section.id.replace('shopify-section-', ''));
    const response = await fetch(request, { headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error('No pudimos cambiar la talla. Intenta seleccionarla otra vez.');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    if (sequence !== form._atomicoVariantSequence) return;
    const fresh = html.getElementById(form.getAttribute('id'));
    const nextId = fresh?.querySelector('input[name="id"]')?.value;
    const freshButton = fresh?.querySelector('[data-add-to-cart]');
    if (!fresh || !nextId || !freshButton) throw new Error('Esta combinación no está disponible. Selecciona otra talla.');
    component.variantId = nextId;
    const input = form.querySelector('input[name="id"]');
    input.value = nextId;
    const controls = form.querySelector('.form__selectors');
    const nextControls = fresh.querySelector('.form__selectors');
    if (controls && nextControls) controls.replaceChildren(...nextControls.childNodes);
    const oldBase = form.dataset.atomicoBasePrice;
    const nextBase = fresh.dataset.atomicoBasePrice;
    if (oldBase !== nextBase) {
      for (const selector of ['.product__price-block--mobile', '.product__price-block--desktop']) {
        const target = section.querySelector(selector);
        const source = html.querySelector(selector);
        if (target && source) target.replaceChildren(...source.childNodes);
      }
      form.dataset.atomicoBasePrice = nextBase;
    }
    if (button) {
      button.disabled = freshButton.disabled;
      const label = button.querySelector('.btn-state-ready');
      const nextLabel = freshButton.querySelector('.btn-state-ready');
      if (label && nextLabel) label.innerHTML = nextLabel.innerHTML;
    }
    if (errors) { errors.textContent = ''; errors.hidden = true; }
    input.dispatchEvent(new Event('change', { bubbles: true }));
    if (!personalizer && media) component.updateProductImage(media);
    if (root.closest('[data-enable-history-state]')?.dataset.enableHistoryState !== 'false') {
      const destination = new URL(url, location.href);
      destination.searchParams.set('variant', nextId);
      history.replaceState(history.state, '', destination);
    }
  } catch (error) {
    if (sequence !== form._atomicoVariantSequence) return;
    if (errors) { errors.textContent = error.message; errors.hidden = false; errors.style.display = 'block'; }
    // Keep checkout disabled until a valid size is selected successfully.
  }
};
  } catch(e) { console.error(e); }
})();

})();
